function durationToDate(seconds) {
  const sec = seconds
  const dateNow = new Date()
  let lang = ''
  const normalDate = dateNow.setSeconds(sec)

  const thisLang = Vue.i18n.locale
  switch (thisLang) {
    case 'en': {
      lang = `${thisLang}-${'US'}`
      break
    }
    case 'pt': {
      lang = `${thisLang}-${'PT'}`
      break
    }
    default: {
      lang = `${thisLang}-${'ES'}`
      break
    }
  }
  const month = new Date(normalDate).toLocaleDateString(lang, {month: 'short'})
  const day = new Date(normalDate).toLocaleDateString(lang, {day: '2-digit'})

  return `${day} ${month[0].toUpperCase()}${month.substring(1)}`
}
function formatDate(departure) {
  const thisLang = Vue.i18n.locale
  const timeZone = this.$administrativeAreaTimeZone

  let lang = ''
  switch (thisLang) {
    case 'en': {
      lang = `${thisLang}`
      break
    }
    case 'pt': {
      lang = `${thisLang}`
      break
    }
    case 'de': {
      lang = `${thisLang}`
      break
    }
    case 'fr': {
      lang = `${thisLang}`
      break
    }
    default: {
      lang = `${thisLang}`
      break
    }
  }
  const month = new Date(departure).toLocaleDateString(lang,
    {timeZone, month: 'short'})
  const day = new Date(departure).toLocaleDateString(lang, {
    timeZone,
    day: '2-digit'
  })
  const hour = new Date(departure).toLocaleTimeString(
    navigator.language, {
      timeZone,
      hour: '2-digit',
      minute: '2-digit'
    }
  )

  return `${day} ${month[0].toUpperCase()}${month.substring(1)} ${hour}`
}

export {durationToDate, formatDate}
